import React, {useState} from "react";
import "./training-certificates.styles.scss";

import CustomButton from "../../commons/custom-button/custom-button.component";
import {shallowEqual, useDispatch, useSelector} from "react-redux";
import EmptyTableComponent from "../empty-component/empty-table-compontent";
import {ClientServices} from "../../../redux/clientdata/client.services";
import {getOldOrderHistory, getTrainingCertificates} from "../../../redux/clientdata/client.action";


function TrainingDataTable({
                             title,
                             filterOne,
                             filterTwo,
                             tableItemsOne,
                             tableItemsTwo,
                             categoriesOne,
                             categoriesTwo,
                             tableOneColumnWidth = "210px",
                             tableTwoColumnWidth = "210px",
                           }) {
  const [tableColumnWidth, setTableColumnWidth] = useState(tableOneColumnWidth);
  const [activeDisplay, setAtiveDisplay] = useState(filterOne);
  const [tableCategories, setTableCategories] = useState(categoriesOne);
  const [tableItems, setTableItems] = useState(tableItemsOne);
  const [showDataTable, setShowDataTable] = useState(false);
  const clientTrainingCertificateList = useSelector(({client}) => client.trainingCertificatesList);
  const cartitemimpersonate = useSelector(
      ({cart}) => cart.impersonateMember, shallowEqual
  );

  const toggleDisplayOne = () => {
    setTableColumnWidth(tableOneColumnWidth);
    setAtiveDisplay(filterOne);
    setTableCategories(categoriesOne);
    setTableItems(tableItemsOne);
  };

  const toggleDisplayTwo = () => {
    setTableColumnWidth(tableTwoColumnWidth);
    setAtiveDisplay(filterTwo);
    setTableCategories(categoriesTwo);
    setTableItems(tableItemsTwo);
  };

  const dispatch = useDispatch();
  const userEmailData = useSelector(({user}) => user.verified_email);
  const userMemberIdData = useSelector(({cart}) => cart.impersonateMember);

  React.useEffect(() => {
    dispatch(getTrainingCertificates(userMemberIdData.memberId));
    dispatch(getOldOrderHistory(userEmailData))
  }, []);

  if (clientTrainingCertificateList.length === 0) {
    return (<EmptyTableComponent message={"No Records Available."}/>);
  }

  const printData = (data, contentType) => {
    //const file = new Blob([pdf], { type: contentType });
    // const fileURL = URL.createObjectURL(file);
    // let w = window.open(fileURL);
    // w.window.print();
    let fileName = 'TraningCertificate.pdf';
    //let url = window.URL.createObjectURL(file);
    let a = document.createElement('a');
    a.href = 'data:application/octet-stream;base64,' + data; //pdf; //url;
    a.download = fileName;
    a.target = "blank";
    a.click();
  };

  //NL:Task172: Download Training Certificate
  const downloadData = (data) => {
    let memberId = null;
    if (cartitemimpersonate) {
      memberId = cartitemimpersonate.memberId;
    }
    ClientServices.getTrainingCertificateFile(data, memberId).then(response => {

      if (response.FileContents !== undefined) {
        //printData(response.FileContents, response.ContentType);
        const arrayBuffer = base64ToArrayBuffer(response.FileContents);
        createAndDownloadBlobFile(arrayBuffer, 'TrainingCertificate');
      }
    });
  }

  function base64ToArrayBuffer(base64) {
    const binaryString = window.atob(base64); // Comment this if not using base64
    const bytes = new Uint8Array(binaryString.length);
    return bytes.map((byte, i) => binaryString.charCodeAt(i));
  }

  function createAndDownloadBlobFile(body, filename, extension = 'pdf') {
    const blob = new Blob([body]);
    const fileName = `${filename}.${extension}`;
    if (navigator.msSaveBlob) {
      // IE 10+
      navigator.msSaveBlob(blob, fileName);
    } else {
      const link = document.createElement('a');
      // Browsers that support HTML5 download attribute
      if (link.download !== undefined) {
        const url = URL.createObjectURL(blob);
        link.setAttribute('href', url);
        link.setAttribute('download', fileName);
        link.style.visibility = 'hidden';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      }
    }
  }

  return (
    <div className="training-data-table">
      <div className="trinity-container">
        <h2 className="d-lg-none">{title}</h2>
        <div className="section-filters mt-3 mb-3">
          <span
            className={`filter
                            ${activeDisplay === filterOne ? "bold" : ""}
                        `}
            onClick={toggleDisplayOne}
          >
            {filterOne}
          </span>

          <span className="adobe-reader">
            <a href={'#'}>Certificate not available until the completion</a>
          </span>

          {/* Comment this out for now, second filter button */}
          {/* <span className="seperator ml-2 mr-2">|</span>

          <span
            className={`filter clickable
                            ${activeDisplay === filterTwo ? "bold" : ""}
                        `}
            onClick={toggleDisplayTwo}
          >
            {filterTwo}
          </span> */}
        </div>
      </div>

      <div className="order-table-container">
        <div className="overflow-width-setter">
          <div className="table-categories mb-3">
            <div className="trinity-container d-flex fluid">
              {tableCategories.map((category) => (
                <h5
                  key={category}
                  style={{ width: tableColumnWidth }}
                  className="category column m-0"
                >
                  <span className="mr-2">{category}</span>
                </h5>
              ))}
            </div>
          </div>

          {clientTrainingCertificateList && (
            <div className="trinity-container">
              <div className="table-items">
                {clientTrainingCertificateList.map((item, i) => {
                  // { customer_id, data, software, edition, version, released, activated, maintenance }
                  return (
                    <>
                      <div key={Math.random() * 100 + i} className="table-item">
                        <div key={Math.random()} id={Math.random()} style={{ width: tableColumnWidth }} className="column">
                          {item.OrderNumber}
                        </div>
                        <div key={Math.random()} id={Math.random()} style={{ width: tableColumnWidth }} className="column">
                          {item.OrderDate}
                        </div>
                        <div key={Math.random()} id={Math.random()} style={{ width: tableColumnWidth }} className="column">
                          {item.Name}
                        </div>
                        <div key={Math.random()} id={Math.random()} style={{ width: tableColumnWidth }} className="column">
                          {item.IssuedTo.toString().replace(",", "")}
                        </div>

                        <div className="column">

                          <CustomButton btndisabled={!item.hasCertificate} onClick={() => downloadData(item.ID)}>
                            {!item.hasCertificate ? "No certificate" : "Download Certificates"}
                          </CustomButton>
                        </div>
                      </div>
                    </>
                  );
                })}
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default TrainingDataTable;
